import React from "react";
import Layout from "../../components/Layout";
import ScrollToTop from "../../components/ScrollToTop";
import SessionCheck from "../../components/SessionCheck";
import NavHeader from "../../components/NavHeader";
import DocumentUploadExtMort from "../../views/MortgageView/doc-upload";

const ExternalDocUpload = () => {
  return (
    <Layout>
      <ScrollToTop />
      <SessionCheck shouldRedirect />
      <NavHeader pageTitle="Mortgage" routeName="mortgage" />
      <DocumentUploadExtMort />
    </Layout>
  );
};

export default ExternalDocUpload;
